// Königreiche von Ruihua - Positionen sind relative %-Werte auf der Karte
export const kingdoms = [
  {
    id: "ruihua",
    name: { de: "Ruìhuá", en: "Ruìhuá" },
    chinese: "瑞华",
    title: { de: "Die glückverheißende Pracht", en: "The Auspicious Splendor" },
    element: { de: "Das Kaiserreich", en: "The Empire" },
    color: "#5c0606",
    x: 59,
    y: 48,
    description: {
      de: "Das Herz aller Reiche. Seit über 5000 Jahren existent. Von Kaiser Zhènyáng regiert.",
      en: "The heart of all realms. Existent for over 5000 years. Ruled by Emperor Zhènyáng."
    },
    politics: {
      de: "Zentrum aller Allianzen. Umfasst alle Reiche in sich.",
      en: "Center of all alliances. Encompasses all realms within itself."
    },
  },
  {
    id: "baisimen",
    name: { de: "Báisǐ Mén", en: "Báisǐ Mén" },
    chinese: "白死门",
    title: { de: "Tor des weißen Todes", en: "Gate of the White Death" },
    element: { de: "Kleines Reich im Süden Ruìhuás", en: "Small realm in the south of Ruìhuá" },
    color: "#d7d7d7",
    x: 55,
    y: 58,
    description: {
      de: "Kultivierung ist hier oberstes Gebot. Bildung ein angesehenes Gut. Heimat von Zīxuě.",
      en: "Cultivation is the paramount principle here. Education, a highly regarded asset. Home to Zīxuě."
    },
    politics: {
      de: "Distanzierter Verbündeter Ruìhuás. Eigene Riten und Bräuche. Sklaven in der Kultivierung.",
      en: "A distant ally of Ruìhuá. Distinct rites and customs. Slaves used in cultivation."
    },
  },
  {
    id: "wuyunfeng",
    name: { de: "Wūyúnfēng", en: "Wūyúnfēng" },
    chinese: "乌云峰",
    title: { de: "Berg der dunklen Wolken", en: "Peak of Dark Clouds" },
    element: { de: "Armee & Kampfkraft", en: "Army & Combat Power" },
    color: "#a80c11",
    x: 63,
    y: 22,
    description: {
      de: "Kriegerisches Volk des Feuers in eisigen Gipfeln. Sklaventreiber. Heimat von Chìyàn.",
      en: "Warlike people of fire dwelling in icy peaks. Slavers. Home of Chìyàn."
    },
    politics: {
      de: "Aggressive Militärmacht und Ausbildungsstätte. Indirekte Rivalität zu Ruìhuá. Gesetze des Kaiserreichs sind hier dehnbar.",
      en: "Aggressive military power and training ground. Indirect rivalry with Ruìhuá. Imperial laws are flexible here."
    },
  },
  {
    id: "hogwan",
    name: { de: "Hogwan", en: "Hogwan" },
    chinese: "호관 / 護關",
    title: { de: "Schützender Durchgang", en: "Protective Pass" },
    element: { de: "Grenz- und Zollpunkt zu den Zentralen Reichen", en: "Border and customs point to the Central Realms" },
    color: "#0b90e9",
    x: 70,
    y: 37,
    description: {
      de: "Grenzkönigreich der Östlichen Reiche zu den Zentralen Reichen. Shuǐlán hält gute Kontakte zu Ānqiáng und die Nordgrenzen zu Wūyúnfēng in Schacht.",
      en: "A border kingdom situated between the Eastern Realms and the Central Realms. Shuǐlán maintains strong ties with Ānqiáng and keeps the northern borders with Wūyúnfēng in check."
    },
    politics: {
      de: "Handelsmacht. Gute Verbindungen zu Ruìhuá. Mächtigstes Reich der Ostreiche.",
      en: "Trading power. Strong ties to Ruìhuá. The most powerful of the Eastern Realms."
    },
  },
  {
    id: "anqiang",
    name: { de: "Ānqiáng", en: "Ānqiáng" },
    chinese: "安墙",
    title: { de: "Die Friedensmauer", en: "The Wall of Peace" },
    element: { de: "Grenz- und Zollpunkt zu den Östlichen Reichen", en: "Border and customs point to the Eastern Realms" },
    color: "#491577",
    x: 63,
    y: 38,
    description: {
      de: "Edles Reich aus heiligen Gärten. Lánzǐ hält gute Kontakte zu Hogwan und den Zentralen Reichen.",
      en: "A noble realm of sacred gardens. Lánzǐ maintains good relations with Hogwan and the Central Realms."
    },
    politics: {
      de: "Zollstaat für Ruìhuá. Verwandt mit Vorfahren der Reinen Erde. Heimat von Lánzǐ.",
      en: "Customs state for Ruìhuá. Related to the ancestors of the Pure Earth."
    },
  },
  {
    id: "fenggang",
    name: { de: "Fēnggǎng", en: "Fēnggǎng" },
    chinese: "丰港",
    title: { de: "Reicher Hafen", en: "Prosperous Harbor" },
    element: { de: "Handelsstaat der Zentralen Reiche am und auf dem Wasser", en: "Coastal trading state of the Central Realms near and on the water." },
    color: "#56a94d",
    x: 70,
    y: 67,
    description: {
      de: "Weite Prärie mit Stadtzentren an den Küsten. Hafenmacht von Ruìhuá. Heimat von Chéngxī.",
      en: "Wide prairie with city centers on the coast. Trading power of Ruìhuá. Home of Chéngxī."
    },
    politics: {
      de: "Treuer Verbündeter Ruìhuás. Wassermacht.",
      en: "Loyal ally of Ruìhuá. Naval power."
    },
  },
  {
    id: "tiantai",
    name: { de: "Tiántài", en: "Tiántài" },
    chinese: "天臺",
    title: { de: "Friedvolles Ackerland", en: "Peaceful Farmland" },
    element: { de: "Harmonie & Landwirtschaft", en: "Harmony & Agriculture" },
    color: "#d4c340",
    x: 40,
    y: 42,
    description: {
      de: "Prächtige Tempel umringt von goldenen Ackerland. Reichtum durch starken Handel und reiche Ernte über Jahrhunderte. Heimat von Lùhuá.",
      en: "Magnificent temples surrounded by golden farmland. Wealthy through strong trade over centuries. Home of Lùhuá."
    },
    politics: {
      de: "Unabhängig. Mystiker des Reiches.",
      en: "Independent. Mystics of the realm."
    },
  },
  {
    id: "hwawon",
    name: { de: "Hwawon", en: "Hwawon" },
    chinese: "화원 / 花園",
    title: { de: "Reich der Rosen", en: "Realm of Roses" },
    element: { 
      de: "Wirtschaftlich schwach und unstrukturiert, aber großer Zusammenhalt von Volk und Reich.", 
      en: "Economically weak and lacking structure, yet with great solidarity between the people and the realm." },
    color: "#7AB6FF",
    x: 82,
    y: 48,
    description: {
      de: "Harmonieliebendes Reich des Ostens. Mit der Geburt Bitgyeols erblühte das Reich und das Königspaar in einem ewigen Frühling.",
      en: "A harmony-loving realm of the East. With the birth of Bitgyeol, the kingdom and the royal couple blossomed in eternal spring."
    },
    politics: {
      de: "Friedliches, abgeschiedenes Reich. Kulturell verbunden mit Sanghang und den Jiwon-Reichen.",
      en: "A peaceful, secluded realm. Culturally connected to Sanghang and the Jiwon realms."
    },
  },
  {
    id: "sanghang",
    name: { de: "Sanghang", en: "Sanghang" },
    chinese: "상항 / 商港",
    title: { de: "Handelshafen", en: "Trading Port" },
    element: { de: "Handelsstaat der Östlichen Reiche am Wasser", en: "Coastal trading state of the Eastern Realms" },
    color: "#e574c1",
    x: 79,
    y: 52,
    description: {
      de: "Hafenstaat am Meer der Östlichen Reiche. Eng Verbunden mit Fenggang. Heimat von Xǐyuè.",
      en: "A port state on the Sea of the Eastern Realms. Closely linked to Fenggang. Home of Xǐyuè."
    },
    politics: {
      de: "Handelspartner mit den Zentralen Reichen. Hauptversorger des Östlichen Küste von Wūyúnfēng.",
      en: "Trading partner of the Central Realms. Primary supplier to the eastern coast of Wūyúnfēng."
    },
  },
  {
    id: "huishan",
    name: { de: "Huīshān", en: "Huīshān" },
    chinese: "灰山",
    title: { de: "Die grauen Berge", en: "The Grey Mountains" },
    element: { de: "Erzreichtum", en: "Mineral & Ore Wealth" },
    color: "#9a9a9a",
    x: 38,
    y: 62,
    description: {
      de: "Raues Gebirge, bekannt für seine unnachgiebigen Minen und wertvollen Metalle.",
      en: "Rugged mountains, known for their unyielding mines and precious metals."
    },
    politics: {
      de: "Wichtiger Erzlieferant des Kaiserreichs. Handelstor zu Xīfāng.",
      en: "Important ore supplier to the Empire. Trading gateway to Xīfāng."
    },
  },
  {
    id: "gaobi",
    name: { de: "Gāobì", en: "Gāobì" },
    chinese: "高壁",
    title: { de: "Die Hohe Wand", en: "The High Wall" },
    element: { de: "Gebirge, das Xīfāng von Ruìhuá trennt", en: "Mountain range separating Xīfāng from Ruìhuá" },
    color: "#7d95ee",
    x: 28,
    y: 30,
    description: {
      de: "Unerklimbare Gipfel mit drei Durchgangspassagen. Bewacht von der Kaiserlichen Armee. Qiángzhōng wurde hier trainiert.",
      en: "Unscalable peaks with three passageways. Guarded by the Imperial Army. Qiángzhōng was trained here."
    },
    politics: {
      de: " Eine natürliche Grenze. Militärisch besetzt von Ruìhuá. Bedingter Durchgang für die Bürger und Händler Xīfāngs.",
      en: "A natural border. Militarily occupied by Ruìhuá. Restricted passage for the citizens and merchants of Xīfāng."
    },
  },
  {
    id: "namjiwon",
    name: { de: "Namjiwon", en: "Namjiwon" },
    chinese: "남지원 / 南地原",
    title: { de: "Kleine, bockige Erde im Süden", en: "Smaller, Stubborn Earth in the South" },
    element: { 
      de: "DieThronfolgenden sind seit Jahren verschollen, daher herrscht viel Anspannung im Volk.", 
      en: "The heirs to the throne have been missing for years, causing great tension among the people." },
    color: "#412200",
    x: 79,
    y: 45,
    description: {
      de: "Sanfte Hügel und malerische Wälder schmücken das Land. Jinwoos Heimat liegt im südlichen Jiwon.",
      en: "Gentle hills and silent forests. Jinwoo's home lies in the souther valley."
    },
    politics: {
      de: "Zersritten mit Bukjiwon. Es herrschten einige Bürgerkriege, doch das Volk wird nun vom Kaiserreich geleitet.",
      en: "Enstranged with Bukjiwon. Several civil wars took place, but the people are now led by the Empire."
    },
  },
  {
    id: "bukjiwon",
    name: { de: "Bukjiwon", en: "Bukjiwon" },
    chinese: "북지원 / 北地原",
    title: { de: "Große, sture Erde im Norden", en: "Great, Stubborn Earth in the North" },
    element: { de: "Thronfolger verschollen, Anspannung im Volk", en: "Heir missing, tension among the people" },
    color: "#210936",
    x: 77,
    y: 43,
    description: {
      de: "Ein einst stolzes Reich der reinen Erde, das nach dem Verschwinden der Herrscherfamilie von Unruhen geplagt wird.",
      en: "A once proud realm of the pure earth,plagued by unrest following the disappearance of the ruling family."
    },
    politics: {
      de: "Zersritten mit Namjiwon. Es herrschten einige Bürgerkriege, doch das Volk wird nun vom Kaiserreich geleitet.",
      en: "Enstranged with Namjiwon. Several civil wars took place, but the people are now led by the Empire."
    },
  },
  {
    id: "xifang",
    name: { de: "Xīfāng", en: "Xīfāng" },
    chinese: "西方",
    title: { de: "Das Gesetzlose Westland", en: "The Lawless West" },
    element: { de: "Rebellen & Unbekanntes Land", en: "Rebels & Unknown Territory" },
    color: "#0303ad",
    x: 15,
    y: 40,
    description: {
      de: "Ein riesiges, unwegsames Gebiet jenseits des Gāobì-Gebirges. Es gilt im Reich als gesetzlos und gefährlich.",
      en: "A vast, rugged territory beyond the Gāobì mountains. It is considered lawless and dangerous within the Empire."
    },
    politics: {
      de: "Rebellen versuchen hier eigene Herrschaften aufzubauen, doch scheitern meistens. Grenzen sind streng bewacht durch die kaiserliche Armee.",
      en: "Rebels attempt to establish their own domains here, but usually fail. Borders are heavily guarded by the imperial army."
    },
  },
  {
    id: "jiaran",
    name: { de: "Jiārán", en: "Jiārán" },
    chinese: "嘉然",
    title: { de: "Inselparadies", en: "Island Paradise" },
    element: { de: "Auf natürliche Weise schön", en: "Naturally Beautiful" },
    color: "#186a49", 
    x: 74, 
    y: 91,
    description: {
      de: "Ein harmonischer und friedvoller Ort, dessen Name für das absolut Gute und die naturbelassene Schönheit steht.",
      en: "A harmonious and peaceful realm whose name represents inherent goodness and untouched beauty."
    },
    politics: {
      de: "Ein friedlicher Urlaubsort abseits kaiserlicher Konflikte, getragen von Harmonie, Ruhe und der Verbundenheit der Inselbewohner zur Natur.",
      en: "A peaceful place for a vacation away from imperial conflicts, sustained by harmony, tranquility, and the islanders' connection to nature."
    },
  },
  {
    id: "xindao",
    name: { de: "Xīndǎo", en: "Xīndǎo" },
    chinese: "心岛",
    title: { de: "Herzinsel", en: "Heart Island" },
    element: { de: "Insel in Form eines Herzens.", en: "An Heart-Shaped Island." },
    color: "#ba0f56",
    x: 96.5, 
    y: 74,
    description: {
      de: "Eine schlichte Insel, deren Gestalt aus der Vogelperspektive einem perfekten Herzen gleicht.",
      en: "A simple island whose shape, viewed from above, perfectly resembles a heart."
    },
    politics: {
      de: "?",
      en: "?"
    },
  },
  {
    id: "daogang",
    name: { de: "Dàogǎng", en: "Dàogǎng" },
    chinese: "盗港",
    title: { de: "Hafen der Diebe", en: "Thieves' Haven" },
    element: { de: "Piratenhafen & Treffpunkt", en: "Pirate Haven & Meeting Place" },
    color: "#0b0050", 
    x: 21.5, 
    y: 68,
    description: {
      de: "Ein berüchtigter Piratenhafen, versteckt vor den Blicken der kaiserlichen Flotte. Hier treffen sich Schmuggler, Diebe und Gestrandete.",
      en: "A notorious pirate port hidden from the eyes of the Imperial Navy. A gathering place for smugglers, thieves, and outcasts."
    },
    politics: {
      de: "Steht unter keiner offiziellen Herrschaft. Ort an dem Gesetze keine Macht besitzen und Informationen ständig die Besitzer wechseln.",
      en: "Under no official rule. A place where laws hold no sway and information constantly trades hands."
    },
  },
  {
    id: "harash",
    name: { de: "Harash", en: "Harash" },
    chinese: "ہراش / 哈拉什",
    title: { de: "Die bewachte Wüste", en: "The Guarded Desert" },
    element: { de: "Der stille Wächter", en: "The Silent Guardian" },
    color: "#d4a359", 
    x: 3,
    y: 30,
    description: {
      de: "Eine ruhige, ehrfurchtgebietende und geheimnisvolle Wüste, die Leben wie Geheimnisse gleichermaßen verschlingt und bewahrt.",
      en: "A tranquil, awe-inspiring, and mysterious desert that absorbs and preserves secrets as much as life itself."
    },
    politics: {
      de: "Ein Land, das sich selbst schützt. Wächter und Scharfschützen behüten die Uralten Pfade vor Eindringlingen, während die Wüste selbst als unüberwindbare Grenze dient.",
      en: "A land that protects itself. Guardians and archers guard the ancient paths from intruders, while the desert itself acts as an impassable border."
    },
  },
];